const initialState = {
	categories: [],
	loading: false,
	errors: null,
};

export default initialState;
